import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "reactive-width backdrop" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-bold" }
const _hoisted_4 = { class: "text-bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { id: "result-map-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "map",
    id: "result-map"
  }, [
    /*#__PURE__*/_createTextVNode(" Something went wrong :( "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Try reloading? ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.final)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(" You picked "),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.final.Name), 1),
          _createTextVNode(" at "),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.final.Vicinity), 1),
          _createTextVNode(" ! "),
          _hoisted_5,
          _createTextVNode(" Don't like your pick? Click the title at the top to go again. ")
        ]))
      : _createCommentVNode("", true)
  ]))
}